/**
 * monoblocc.jp → LINE: record the tap, so the follow can be traced back to it.
 *
 * A LINE add link (lin.ee/…) cannot carry our parameters — LINE drops them, and
 * the follow webhook arrives with no referrer. The LP solves this by recording a
 * `line_click` the moment the button is tapped; lib/line-follow-attribution.js
 * then joins each follow to the tap 3–14 seconds before it, and the tap carries
 * the utm_* / fbclid of the visit. This does the same for the storefront, into
 * the same table, so a follow that started on monoblocc.jp is attributed to the
 * ad (or article, or search) that brought the visitor — not lost as "unknown".
 *
 * The visit's params are the ones monoblocc-variant-intent.js already keeps in
 * sessionStorage (`mb_store_params`): Shopify drops the query string on internal
 * navigation, so the page a visitor taps LINE on is rarely the one they landed on.
 *
 * ?mtid=mb_test on any page marks the tap as a rehearsal (is_test), like the LP.
 */
(function () {
  "use strict";

  var ENDPOINT = "https://monoblocc-preorder.vercel.app/api/track";
  var PARAMS_KEY = "mb_store_params";
  var SESSION_KEY = "mb_store_session";
  var LINE_LINK = /(^|\/\/)(lin\.ee|line\.me)\//i;

  function ss() {
    try { var s = window.sessionStorage; s.setItem("__mb", "1"); s.removeItem("__mb"); return s; }
    catch (e) { return null; }
  }
  function id() {
    try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) {}
    return "mb-" + Math.random().toString(36).slice(2) + "-" + String(Date.now());
  }
  function sessionId(s) {
    if (!s) return id();
    var v = s.getItem(SESSION_KEY);
    if (!v) { v = id(); s.setItem(SESSION_KEY, v); }
    return v;
  }
  function visitParams(s) {
    var out = {};
    try { out = JSON.parse((s && s.getItem(PARAMS_KEY)) || "{}") || {}; } catch (e) { out = {}; }
    try {
      var q = new URLSearchParams(window.location.search);
      ["mtid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"].forEach(function (k) {
        var v = q.get(k);
        if (v) out[k] = String(v).slice(0, 200);
      });
      if (s) s.setItem(PARAMS_KEY, JSON.stringify(out));
    } catch (e) {}
    return out;
  }
  function cookie(n) {
    var m = document.cookie.match(new RegExp("(^|; )" + n + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

  // Captured at load, so the params survive even if the tap is on a later page.
  var store = ss();
  visitParams(store);

  document.addEventListener("click", function (e) {
    try {
      if (!e.isTrusted) return;
      var a = e.target && e.target.closest && e.target.closest("a[href]");
      if (!a || !LINE_LINK.test(a.getAttribute("href") || "")) return;
      var p = visitParams(store);
      var section = a.closest("[id^='shopify-section-']");
      var payload = {
        type: "line_click",
        clientId: sessionId(store),
        viewId: id(),
        utmSource: p.utm_source || null,
        utmMedium: p.utm_medium || null,
        utmCampaign: p.utm_campaign || null,
        utmContent: p.utm_content || null,
        fbclid: p.fbclid || null,
        fbp: cookie("_fbp"),
        fbc: cookie("_fbc"),
        // Where on the store the tap happened: the board splits LP vs store by this.
        ctaButton: "store_line",
        pageVariant: ("store:" + window.location.pathname).slice(0, 120),
        pageUrl: window.location.href.slice(0, 500),
        referrer: (document.referrer || "").slice(0, 500) || null,
        section: section ? section.id.replace("shopify-section-", "").slice(0, 80) : null,
        isTest: p.mtid === "mb_test" || undefined
      };
      // fetch+keepalive: survives the navigation to LINE the tap starts. text/plain
      // keeps it a simple request (no preflight to lose on the way out).
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: "cors",
        credentials: "omit"
      }).catch(function () {});
    } catch (err) { /* tracking never blocks the tap */ }
  }, true);
})();
